// 'use strict';
/*
*   IHT, Oct 2017
*   Rejigging of
*   react-cartographer: "^0.4.3"
*   in order to make some small edits.
*/

Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports.default = Map;

const _react = require('react');

const _react2 = _interopRequireDefault(_react);

const _propTypes = require('prop-types');

const _propTypes2 = _interopRequireDefault(_propTypes);

const _mapLocationFactory = require('../lib/mapLocationFactory');

const _mapLocationFactory2 = _interopRequireDefault(_mapLocationFactory);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// Factory
const factory = new _mapLocationFactory2.default(); /**
                                                   * Copyright 2015, Yahoo! Inc.
                                                   * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
                                                   */
function Map(props) {
    const location = factory.getMap({
        providerKey: props.providerKey,
        provider: props.provider,
        mapId: props.mapId,
        line1: props.addressLine1,
        // line2: [props.city, props.state].join(','),
        // line3: props.country,
        longitude: props.longitude,
        latitude: props.latitude,
        height: props.height,
        width: props.width,
        zoom: props.zoom,
    });
    let locationText = void 0;
    let locationLink = void 0;
    let style = void 0;

    if (!location.data || !location.data.locationLink) {
        return null;
    }

    locationText = location.data.locationText;
    locationLink = location.data.locationLink;
 
    style = {
        width: props.width,
        height: props.height,
    };

    if (props.useBackgroundImageStyle) {
        style = {
            width: '100%',
            height: props.height,
            background: `url(${locationLink}) no-repeat`,
        };
    }

    return _react2.default.createElement(
        'div',
        { style, className: 'cartographer-container' },
        !props.useBackgroundImageStyle
            ? _react2.default.createElement('img', {
                src: locationLink,
                alt: locationText,
                title: locationText,
                onError: props.callback
            })
            : null,
    );
}

Map.propTypes = {
    providerKey: _propTypes2.default.string.isRequired,
    provider: _propTypes2.default.oneOf(['yahoo', 'google', 'bing']),
    mapId: _propTypes2.default.string.isRequired,
    addressLine1: _propTypes2.default.string,
    city: _propTypes2.default.string,
    state: _propTypes2.default.string,
    country: _propTypes2.default.string,
    longitude: _propTypes2.default.number,
    latitude: _propTypes2.default.number,
    height: _propTypes2.default.number.isRequired,
    width: _propTypes2.default.number.isRequired,
    zoom: _propTypes2.default.number,
    useBackgroundImageStyle: _propTypes2.default.bool,
};

Map.defaultProps = {
    provider: 'yahoo',
    mapId: 'map',
    height: 270,
    width: 580,
    zoom: 10,
    useBackgroundImageStyle: false,
};



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Meeting/components/react-cartographer/lib/components/Map.js